import React from 'react';
import { Amount } from '@akropolis-web/primitives';

import { FormattedAmount } from 'components/FormattedAmount';
import { toEither } from 'utils/either';
import { FormattedAmountProps } from 'components/FormattedAmount/types';
import { FallbackedTotalUSD as FallbackedTotalUSDType } from 'domain/types';
import { getAmount, isZero } from 'domain/utils';

export type FallbackedTotalUSDProps = {
  displayTokenAmounts?: boolean;
  formattedAmountProps?: Omit<FormattedAmountProps<Amount>, 'sum'>;
  renderZero?: () => JSX.Element;
} & FallbackedTotalUSDType;

export function FallbackedTotalUSD({
  value,
  fallback,
  displayTokenAmounts = false,
  formattedAmountProps,
  renderZero,
}: FallbackedTotalUSDProps) {
  if (isZero({ fallback, value })) {
    return renderZero ? (
      renderZero()
    ) : (
      <FormattedAmount {...formattedAmountProps} sum={getAmount(0, '$')} />
    );
  }

  if (displayTokenAmounts) {
    return (
      <div>
        {[...fallback.amountsWithPrice, ...fallback.amountsWithoutPrice].map((amount, index) => (
          <div key={index}>
            <FormattedAmount {...formattedAmountProps} sum={amount} />
          </div>
        ))}
      </div>
    );
  }

  return toEither(value).fold(
    amount => <FormattedAmount {...formattedAmountProps} sum={amount} />,
    () => (
      <div>
        {fallback.partialTotalUSD.gt(0) && (
          <FormattedAmount {...formattedAmountProps} sum={fallback.partialTotalUSD} />
        )}
        {fallback.amountsWithoutPrice.map((amount, index) => (
          <div key={index}>
            <FormattedAmount {...formattedAmountProps} sum={amount} />
          </div>
        ))}
      </div>
    ),
  );
}
